import React, { useState, useEffect } from "react";
import moment from "moment";
import { withRouter } from "react-router";
import { useSnackbar } from "notistack";
import MomentUtils from '@date-io/moment';
import { Button, Grid, Paper, TextField } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { regexConstants } from "../../../constants/regEx";
import EditIcon from '@material-ui/icons/Edit';
import { checkApiStatus, checkPermission } from "../../utils_v2";
import { globalPutService } from "../../../globalServices";
import { assetTypeValues, backendDateFormat, fieldDateFormat } from "../../../constants";
import { PageLoader } from "../../shared_elements";
import { trackActivity } from "../../../utils/mixpanel";
import { hanwahaInstance, regionalOneInstance, testLessor } from "../../../shared/components";
import { getPermissionKey } from "..";

const ShopVisitCard = ({ params, shopVistInfo, shopvisit, setShopvisit, isEdit, setEdit, onFieldChange, assetInfoData }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [error, seterror] = useState({});
    const editShopVisitInfo = () => {
        let validationInputs = {};
        validationInputs = {
            ...validationInputs,
            mtbr_as_of_date: shopvisit?.mtbr ? shopvisit?.mtbr_as_of_date && moment(shopvisit?.mtbr_as_of_date).isValid() ? '' : 'Please Enter MTBR As of Date':'' ,
            egtm_as_of_date: shopvisit?.egtm ? shopvisit?.egtm_as_of_date && moment(shopvisit.egtm_as_of_date).isValid() ? '' : 'Please Enter EGTM As of Date':''
        }
        // if (shopvisit?.mtbr && shopvisit?.mtbr_as_of_date || shopvisit?.egtm && shopvisit?.egtm_as_of_date ) {
        //     if (!moment(shopvisit?.mtbr_as_of_date).isValid()) {
        //         validationInputs = {
        //             ...validationInputs,
        //             mtbr_as_of_date: "Enter valid MTBR As of Date"
        //         }
        //     }
        //     if (!moment(shopvisit?.egtm_as_of_date).isValid()) {
        //         validationInputs = {
        //             ...validationInputs,
        //             egtm_as_of_date: "Enter valid EGTM As of Date"
        //         }
        //     }
        // }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            let payload = Object.assign({}, shopvisit)
            payload = {
                ...payload,
                mtbr_as_of_date: moment(shopvisit?.mtbr_as_of_date).isValid() ? shopvisit?.mtbr_as_of_date : null,
                egtm_as_of_date: moment(shopvisit.egtm_as_of_date).isValid() ? shopvisit.egtm_as_of_date : null,
                mtbr: shopvisit.mtbr ? shopvisit.mtbr :null,
                egtm: shopvisit.egtm ? shopvisit.egtm :null
            }
            globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/shop_visit_card/`, payload)
                .then(response => {
                    if (checkApiStatus(response)) {
                        setEdit(false);
                        enqueueSnackbar('Shop Visit Updated Sucessfully', { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                        trackActivity('Console Management', { page_title: 'ShopVisit Info', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited ShopVisit Info data from Edit ShopVisit Info form' });
                    }
                    setLoading(false)
                })
        } else {
            seterror(validationInputs)
        }
    }
    const onResetError = (key) => seterror({ ...error, [key]: '' })

    return (
        <Paper className="console-forms-fields" style={{ padding: '20px 10px', marginBottom: '15px', position: 'relative' }}>
            {checkPermission('technical_specs', getPermissionKey(params.type), 'U') && !isEdit && hanwahaInstance?
                <span className="edit-basic-info" style={{ top: "0px", right: "1px" }}>
                    <EditIcon onClick={() => setEdit(true)} fontSize="small" color='primary' />
                </span> : null
            }
            <Grid container spacing={1}>
                <Grid item md={4}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                            disabled={true}
                            margin="normal"
                            name="shop_vist_date"
                            label="Last Shop Visit Date"
                            format={fieldDateFormat}
                            fullWidth
                            disableFuture
                            InputLabelProps={{ shrink: true }}
                            value={shopvisit?.shop_vist_date || null}
                            inputVariant='outlined'
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item md={4}>
                    <TextField
                        disabled={true}
                        name='tslsv'
                        label='TSLSV'
                        value={shopvisit?.tslsv === null ? '' : shopvisit?.tslsv === 0 ? '0' : shopvisit?.tslsv ? (shopvisit?.tslsv)?.toFixed(2) : ''}
                        fullWidth
                        margin="normal"
                        inputProps={{ maxLength: 10 }}
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                    />
                </Grid>
                <Grid item md={4}>
                    <TextField
                        disabled={true}
                        name='cslsv'
                        label='CSLSV'
                        value={shopvisit?.cslsv === null ? '' :shopvisit?.cslsv === 0 ? '0' : shopvisit?.cslsv ? (shopvisit?.cslsv)?.toFixed(2):''}
                        fullWidth
                        inputProps={{ maxlength: 10 }}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                    />
                </Grid>
                {regionalOneInstance||testLessor ? <>
                <Grid item md={4}>
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                            disabled={true}
                            margin="normal"
                            name="last_prsv_date"
                            label="Last PRSV Date"
                            format={fieldDateFormat}
                            fullWidth
                            disableFuture
                            InputLabelProps={{ shrink: true }}
                            value={shopvisit?.last_prsv_date || null}
                            inputVariant='outlined'
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item md={4}>
                    <TextField
                        disabled={true}
                        name='tslpr'
                        label='TSLPR'
                        value={shopvisit?.tslpr === null ? '' : shopvisit?.tslpr ===  0 ? '0' : shopvisit?.tslpr ? (shopvisit?.tslpr)?.toFixed(2):''}
                        fullWidth
                        inputProps={{ maxlength: 10 }}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                    />
                </Grid>
                <Grid item md={4}>
                    <TextField
                        disabled={true}
                        name='cslpr'
                        label='CSLPR'
                        value={shopvisit?.cslpr === null ? '' : shopvisit?.cslpr === 0 ? '0' : shopvisit?.cslpr ? (shopvisit?.cslpr)?.toFixed(2):''}
                        fullWidth
                        inputProps={{ maxlength: 10 }}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                    />
                </Grid></>:null}
                {hanwahaInstance ?<>
                <Grid item md={4}>
                    <TextField
                        disabled={!isEdit}
                        name='mtbr'
                        label='MTBR'
                        value={shopvisit?.mtbr === null ? '' : shopvisit?.mtbr === 0 ? '0' : shopvisit?.mtbr ? shopvisit?.mtbr : null}
                        fullWidth
                        inputProps={{ maxlength: 10 }}
                        onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('mtbr', e.target.value) : e.preventDefault()}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                    />
                </Grid>
                <Grid item md={4} >
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                            required={shopvisit?.mtbr}
                            disabled={!isEdit}
                            margin="normal"
                            name="mtbr_as_of_date"
                            label="MTBR As of Date"
                            format={fieldDateFormat}
                            fullWidth
                            disableFuture
                            InputLabelProps={{ shrink: true }}
                            minDate={moment().subtract(25, 'years')}
                            value={shopvisit?.mtbr_as_of_date || null}
                            onChange={(data, value) => { onFieldChange('mtbr_as_of_date', moment(data) ? moment(data).format(backendDateFormat) : null); onResetError('mtbr_as_of_date')}}
                            inputVariant='outlined'
                            error={error.mtbr_as_of_date ? true : false}
                            helperText={error.mtbr_as_of_date || ''}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid item md={4}>
                    <TextField
                        disabled={!isEdit}
                        name='egtm'
                        label='EGTM'
                        value={shopvisit?.egtm === null ? '' : shopvisit?.egtm === 0 ? '0' : shopvisit?.egtm ? shopvisit?.egtm : ''}
                        fullWidth
                        inputProps={{ maxlength: 10 }}
                        onChange={(e) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('egtm', e.target.value) : e.preventDefault()}
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        variant='outlined'
                    />
                </Grid>
                <Grid item md={4} >
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        <KeyboardDatePicker
                            required={shopvisit?.egtm}
                            disabled={!isEdit}
                            margin="normal"
                            name="egtm_as_of_date"
                            label="EGTM As of Date"
                            format={fieldDateFormat}
                            fullWidth
                            disableFuture
                            InputLabelProps={{ shrink: true }}
                            minDate={moment().subtract(25, 'years')}
                            value={shopvisit?.egtm_as_of_date || null}
                            onChange={(data, value) => { onFieldChange('egtm_as_of_date', moment(data) ? moment(data).format(backendDateFormat) : null);onResetError('egtm_as_of_date') }}
                            inputVariant='outlined'
                            error={error.egtm_as_of_date ? true : false}
                            helperText={error.egtm_as_of_date || ''}
                        />
                    </MuiPickersUtilsProvider>
                </Grid></>:null}
            </Grid>
            {isEdit ?
                <ul className="list-inline" style={{ paddingTop: '10px' }}>
                    <li className="list-inline-item">
                        <Button onClick={() => { setEdit(false); shopVistInfo('pageLoader'); seterror('') }} color="primary" size='small' variant="outlined">Cancel</Button>
                    </li>
                    <li className="list-inline-item">
                        <Button onClick={editShopVisitInfo} color="primary" size='small' variant="contained">SAVE</Button>
                    </li>
                </ul> : null
            }
            {isLoading ? <PageLoader /> : null}        </Paper>
    )
}
export default withRouter(ShopVisitCard);